import BasePopup from '../Base/BasePopup';

export default BasePopup;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-tree-select@2.5.0@rc-tree-select/es/Popup/MultiplePopup.js
// module id = 845
// module chunks = 0